import React from 'react';
import SeccionPreviewUsuario from './Preview/SeccionPreviewUsuario';
import SeccionPreviewRol from './Preview/SeccionPreviewRol';
import SeccionPreviewDelegacion from './Preview/SeccionPreviewDelegacion';
import SeccionPreviewProfesional from './Preview/SeccionPreviewProfesional';
import SeccionPreviewPaciente from './Preview/SeccionPreviewPaciente';
import SeccionPreviewCliente from './Preview/SeccionPreviewCliente';

export default function SeccionPreview({ usuario, roles, regiones, delegaciones, delegacionesSeleccionadas, delegacionOrigen, profesional, pacienteSeleccionado, clientesSeleccionados, idTipoUsuario, instituciones }) {

    return (
        <>
            <SeccionPreviewUsuario usuario={usuario} />
            <SeccionPreviewRol roles={roles} />
            <SeccionPreviewDelegacion
                regiones={regiones}
                delegaciones={delegaciones}
                delegacionesSeleccionadas={delegacionesSeleccionadas}
                delegacionOrigen={delegacionOrigen}
            />
            <SeccionPreviewProfesional profesional={profesional} idTipoUsuario={idTipoUsuario} instituciones={instituciones} />
            <SeccionPreviewPaciente pacienteSeleccionado={pacienteSeleccionado} idTipoUsuario={idTipoUsuario} />
            <SeccionPreviewCliente clientesSeleccionados={clientesSeleccionados} idTipoUsuario={idTipoUsuario} />
        </>

    );
};